module.exports = __webpack_public_path__ + "media/images/WFC_Landscape_White_w_0-236b957946d7477cce298b8a218745f1.svg";